// src/components/BoardTheme/GlobalSettingsPanel.js

import React from 'react';
import { toast } from 'react-toastify';
import { themeTypeOptions } from './ThemeLists.js';
import CustomColorPicker from './CustomColorPicker'; // Import the CustomColorPicker
import Checkbox from '@mui/material/Checkbox';

const GlobalSettingsPanel = ({
  themeName,
  setThemeName,
  mainColor,
  setMainColor,
  debugRandom,
  setDebugRandom,
  backgroundColor,
  setBackgroundColor,
  distanceUnit,
  setDistanceUnit,
  temperatureUnit,
  setTemperatureUnit,
  setSnapToGridEnabled,
  setDebugOverlaps,
  setGridSize,
  setScale,
  themeType,
  setThemeType,
  debugOverlaps,
  snapToGridEnabled,
  gridSize,
  scale,
}) => {
  const handleDistanceUnitChange = (e) => {
    setDistanceUnit(e.target.value);
  };

  const handleTemperatureUnitChange = (e) => {
    setTemperatureUnit(e.target.value);
  };

  const handleThemeTypeChange = (e) => {
    setThemeType(e.target.value);
  };

  const handleThemeNameChange = (e) => {
    setThemeName(e.target.value);
  };

  return (
    <div>
      <h3>Global Settings</h3>

      {/* Theme Name Input */}
      <div style={styles.settingItem}>
        <label htmlFor="themeName">Theme Name:</label>
        <input
          type="text"
          id="themeName"
          value={themeName}
          onChange={handleThemeNameChange}
          placeholder="Enter theme name"
          style={styles.textInput}
          aria-label="Enter Theme Name"
        />
      </div>

      {/* Theme Type Selection */}
      <div style={styles.settingItem}>
        <label htmlFor="themeTypeSelect">Theme Type:</label>
        <select
          id="themeTypeSelect"
          value={themeType}
          onChange={handleThemeTypeChange}
          style={styles.selectInput}
          aria-label="Select Theme Type"
        >
          {themeTypeOptions.map((option) => (
            <option key={`themeType-${option.value}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Background Color */}
      <CustomColorPicker
        label="Background Color"
        color={backgroundColor}
        onChange={setBackgroundColor}
      />

      {/* Distance Unit Type */}
      <div style={styles.settingItem}>
        <label htmlFor="distanceUnit">Distance Unit:</label>
        <select
          id="distanceUnit"
          value={distanceUnit}
          onChange={handleDistanceUnitChange}
          style={styles.selectInput}
          aria-label="Select Distance Unit"
        >
          <option value="metric">Metric (Kilometers)</option>
          <option value="imperial">Imperial (Miles)</option>
        </select>
      </div>

      {/* Temperature Unit Type */}
      <div style={styles.settingItem}>
        <label htmlFor="temperatureUnit">Temperature Unit:</label>
        <select
          id="temperatureUnit"
          value={temperatureUnit}
          onChange={handleTemperatureUnitChange}
          style={styles.selectInput}
          aria-label="Select Temperature Unit"
        >
          <option value="celsius">Celsius (°C)</option>
          <option value="fahrenheit">Fahrenheit (°F)</option>
        </select>
      </div>

      {/* Snap to Grid Toggle */}
      <div style={styles.settingItemCheckbox}>
        <label htmlFor="snapToGrid">Snap to Grid:</label>
        <Checkbox
          id="snapToGrid"
          checked={snapToGridEnabled}
          onChange={(e) => setSnapToGridEnabled(e.target.checked)}
          style={styles.checkboxInput}
          aria-label="Toggle Snap to Grid"
        />
      </div>

      {/* Grid Size Configuration */}
      <div style={styles.settingItem}>
        <label htmlFor="gridSize">Grid Size:</label>
        <input
          type="number"
          id="gridSize"
          value={gridSize}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (value >= 5 && value <= 100) {
              setGridSize(value);
            } else {
              toast.error('Grid size must be between 5 and 100.');
            }
          }}
          min="5"
          max="100"
          step="1"
          style={styles.numberInput}
          aria-label="Set Grid Size"
        />
      </div>

      {/* Debug Overlaps Toggle */}
      <div style={styles.settingItemCheckbox}>
        <label htmlFor="debugOverlaps">Debug Overlaps on SmartDisplay:</label>
        <Checkbox
          id="debugOverlaps"
          checked={debugOverlaps}
          onChange={(e) => setDebugOverlaps(e.target.checked)}
          style={styles.checkboxInput}
          aria-label="Toggle Debug Overlaps"
        />
      </div>

      {/* Debug with random values on SmartDisplay */}
      <div style={styles.settingItemCheckbox}>
        <label htmlFor="debugOverlaps">Debug with random values on SmartDisplay:</label>
        <Checkbox
          id="debugRandom"
          checked={debugRandom}
          onChange={(e) => setDebugRandom(e.target.checked)}
          style={styles.checkboxInput}
          aria-label="Toggle Debug Random"
        />
      </div>

    </div>
  );
};

const styles = {
  settingItem: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '5px',
  },
  settingItemCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between', // Added to push checkbox to the right
    alignItems: 'center',
    marginBottom: '5px',
  },
  selectInput: {
    padding: '5px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  checkboxInput: {
    marginTop: '5px',
    padding: '0px',
    cursor: 'pointer',
  },
  numberInput: {
    marginTop: '5px',
    padding: '5px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%',
  },
  textInput: {
    marginTop: '5px',
    padding: '5px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%',
  },
};

export default GlobalSettingsPanel;
